import { render, staticRenderFns } from "./SaveGroupListTemplateModal.vue?vue&type=template&id=6a6aff4a&"
import script from "./SaveGroupListTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SaveGroupListTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports